<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import { Handle, Position } from '@vue-flow/core'
import NodeBurgerMenu from '@/components/NodeBurgerMenu.vue'
import ParallelLinesIcon from '@/components/ParallelLinesIcon.vue'

const props = defineProps(['id', 'label', 'data', 'type'])
const emit = defineEmits(['editNode', 'removeNode'])

const removeNode = () => { emit('removeNode', props.id) }
const editNode = () => { emit('editNode', props.id) }

const unmappedArtifactCount = computed(() => props.data?.unmapped_artifact_count || 0)

</script>

<template>
  <Handle
    v-if="type != 'input'"
    type="target"
    :position="Position.Top"
  />

  <div class="relative">
    <ParallelLinesIcon
      v-if="type == 'parallel'"
      :color="props.data?.color"
      :size="props.data?.size"
    />

    <NodeBurgerMenu
      @delete="removeNode"
      @edit="editNode"
      :node-type="props.type"
    />

    <div
      v-if="unmappedArtifactCount > 0"
      class="unmapped-badge"
      :title="`${unmappedArtifactCount} unmapped artifact${unmappedArtifactCount === 1 ? '' : 's'}`"
    >
      <span aria-hidden="true">&#9888;</span>
      <span>{{ unmappedArtifactCount }}</span>
    </div>

    <div class="flex flex-col">
      <div class="text-center text-xl font-bold">{{ label }}</div>
    </div>
  </div>

  <Handle type="source" :position="Position.Bottom" />
</template>

<style scoped>
.unmapped-badge {
  position: absolute;
  top: -10px;
  left: -10px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 9999px;
  background-color: #fef3c7;
  color: #92400e;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid #f59e0b;
  z-index: 10;
}
</style>
